/**
 * XOXO birthstone ring preview.
 * Draw order: base (metal+N) → stones at seat-map → claws (metal+N).
 * CRITICAL: NEVER auto-show / scroll on selection complete.
 * Preview stays hidden until the user clicks View preview.
 */
(function () {
  const root = document.querySelector('[data-xoxo-preview]');
  const options = document.querySelector('[data-xoxo-options]');
  if (!root || !options) return;

  const mediaWrapper = root.closest('.product__media-wrapper');
  const canvas = root.querySelector('canvas');
  const ctx = canvas.getContext('2d');
  const status = options.querySelector('[data-xoxo-status]');
  const viewButton = options.querySelector('[data-xoxo-view]');
  const backButton = root.querySelector('.xoxo-back-options');
  const monthKey = {
    January: 'jan', February: 'feb', March: 'mar', April: 'apr',
    May: 'may', June: 'jun', July: 'jul', August: 'aug',
    September: 'sep', October: 'oct', November: 'nov', December: 'dec'
  };
  const images = {};
  let renderVersion = 0;
  let hasRendered = false;
  let previewVisible = false;
  let lastError = '';

  const seatMapEl = root.querySelector('#xoxo-seat-map');
  let seatMap = {};
  try {
    seatMap = JSON.parse(seatMapEl ? seatMapEl.textContent : '{}');
  } catch (e) {
    console.error('XOXO seat map parse failed', e);
  }

  function load(src) {
    return new Promise((resolve, reject) => {
      if (!src) return reject(new Error('Missing XOXO asset URL'));
      if (images[src]) return resolve(images[src]);
      const image = new Image();
      // Avoid CORS-tainted canvas (breaks getImageData). Same-shop CDN is fine without CORS for drawImage.
      image.onload = () => {
        images[src] = image;
        resolve(image);
      };
      image.onerror = () => reject(new Error('XOXO asset failed to load: ' + src));
      image.src = new URL(src, window.location.href).href;
    });
  }

  // IMPORTANT: do NOT use element.dataset for data-*-N attrs.
  // HTML maps data-silver-template-4 → dataset["silverTemplate-4"] (hyphen kept before digits),
  // so dataset.silverTemplate4 is undefined. Always use getAttribute.
  function assetUrl(metal, kind, n) {
    const m = String(metal || 'Silver').toLowerCase().replace(/[^a-z]/g, '');
    const metalKey = m.indexOf('gold') !== -1 ? 'gold' : 'silver';
    return root.getAttribute('data-' + metalKey + '-' + kind + '-' + n);
  }

  function monthAsset(month) {
    const key = monthKey[month];
    return key ? root.getAttribute('data-' + key) : null;
  }

  function readMetal() {
    const fieldsets = document.querySelectorAll('variant-selects fieldset, variant-selects [data-xoxo-option]');
    for (const fs of fieldsets) {
      const legend = (fs.querySelector('legend, .form__label, label.form__label')?.textContent || fs.getAttribute('data-xoxo-option') || '').toLowerCase();
      if (legend.includes('metal')) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;
        const sel = fs.querySelector('select');
        if (sel) return sel.value;
      }
    }
    const radios = document.querySelectorAll('variant-selects input[type="radio"]:checked');
    for (const r of radios) {
      if (/gold|silver/i.test(r.value)) return r.value;
    }
    return 'Silver';
  }

  function readStoneCount() {
    const marked = document.querySelector('[data-xoxo-stone-count-option]');
    if (marked) {
      const checked = marked.querySelector('input[type="radio"]:checked');
      if (checked) {
        const n = parseInt(String(checked.value).replace(/\D/g, ''), 10);
        if (n >= 1 && n <= 6) return n;
      }
      const sel = marked.querySelector('select');
      if (sel) {
        const n = parseInt(String(sel.value).replace(/\D/g, ''), 10);
        if (n >= 1 && n <= 6) return n;
      }
    }
    const fieldsets = document.querySelectorAll('variant-selects fieldset, variant-selects [data-xoxo-option]');
    for (const fs of fieldsets) {
      const legend = (fs.querySelector('legend, .form__label, label.form__label')?.textContent || fs.getAttribute('data-xoxo-option') || '').toLowerCase();
      if (legend.includes('stone') && (legend.includes('number') || legend.includes('of') || legend.includes('qty') || legend.includes('count'))) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) {
          const n = parseInt(String(checked.value).replace(/\D/g, ''), 10);
          if (n >= 1 && n <= 6) return n;
        }
      }
    }
    for (const fs of fieldsets) {
      const legend = (fs.querySelector('legend')?.textContent || '').toLowerCase();
      if (!legend.includes('size') && !legend.includes('metal')) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked && /^[1-6]$/.test(String(checked.value).trim())) {
          return parseInt(checked.value, 10);
        }
      }
    }
    return 1;
  }

  function syncStonePickers(n) {
    for (let i = 1; i <= 6; i++) {
      const fieldset = options.querySelector('[data-xoxo-stone-fieldset="' + i + '"]');
      if (!fieldset) continue;
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      const active = i <= n;
      fieldset.hidden = !active;
      inputs.forEach((input) => {
        input.disabled = !active;
        if (!active) {
          input.checked = false;
          input.removeAttribute('required');
        } else {
          input.required = true;
        }
      });
    }
  }

  function selection() {
    const n = readStoneCount();
    const metal = readMetal();
    const stones = [];
    for (let i = 1; i <= n; i++) {
      const checked = options.querySelector('[data-xoxo-select="' + i + '"] input:checked');
      stones.push(checked ? checked.value : null);
    }
    return { n, metal, stones };
  }

  function isComplete(chosen) {
    return chosen.stones.length === chosen.n && chosen.stones.every(Boolean);
  }


  function missingStoneLabels(chosen) {
    const missing = [];
    for (let i = 0; i < chosen.n; i++) {
      if (!chosen.stones[i]) missing.push('Stone ' + (i + 1));
    }
    return missing;
  }

  function findProductForm() {
    return document.querySelector('product-form form[data-type="add-to-cart-form"]')
      || document.querySelector('form[data-type="add-to-cart-form"]')
      || document.querySelector('product-form form');
  }

  function updateAtcGate(chosen) {
    chosen = chosen || selection();
    const complete = isComplete(chosen);
    const form = findProductForm();
    const productForm = form ? (form.closest('product-form') || form.parentElement) : document.querySelector('product-form');
    const buttonsWrap = form
      ? form.querySelector('.product-form__buttons')
      : document.querySelector('.product-form__buttons');
    const submitBtn = form
      ? form.querySelector('button[type="submit"][name="add"], button.product-form__submit')
      : document.querySelector('button.product-form__submit');
    const gateEl = document.querySelector('[data-xoxo-atc-gate]');

    if (buttonsWrap) buttonsWrap.classList.toggle('xoxo-atc-incomplete', !complete);
    if (productForm) productForm.classList.toggle('xoxo-atc-incomplete', !complete);
    if (form) form.classList.toggle('xoxo-atc-incomplete', !complete);

    if (submitBtn) {
      if (
        submitBtn.getAttribute('data-xoxo-gate') !== 'true'
        && submitBtn.disabled
        && /sold|unavailable/i.test((submitBtn.textContent || '').trim())
      ) {
        submitBtn.setAttribute('data-xoxo-sold-out', 'true');
      }
      const soldOut = submitBtn.getAttribute('data-xoxo-sold-out') === 'true';
      if (!complete || soldOut) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        if (!complete) submitBtn.setAttribute('data-xoxo-gate', 'true');
      } else {
        submitBtn.disabled = false;
        submitBtn.setAttribute('aria-disabled', 'false');
        submitBtn.removeAttribute('data-xoxo-gate');
      }
    }

    document.querySelectorAll(
      '.shopify-payment-button, .shopify-payment-button__button, accelerated-checkout, shopify-accelerated-checkout'
    ).forEach((el) => {
      if (!complete) {
        el.setAttribute('aria-disabled', 'true');
        el.setAttribute('data-xoxo-gate', 'true');
        try { el.disabled = true; } catch (e) {}
      } else if (el.getAttribute('data-xoxo-gate') === 'true') {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('data-xoxo-gate');
        try { el.disabled = false; } catch (e) {}
      }
    });

    if (gateEl) {
      if (complete) {
        gateEl.hidden = true;
        gateEl.textContent = '';
      } else {
        const missing = missingStoneLabels(chosen);
        gateEl.textContent = missing.length
          ? ('Select a birth month for ' + missing.join(', ') + ' before adding to cart.')
          : 'Select a birth month for each stone before adding to cart.';
        gateEl.hidden = false;
      }
    }
  }

  function blockIncompleteSubmit(event) {
    const chosen = selection();
    if (isComplete(chosen)) return;
    event.preventDefault();
    event.stopPropagation();
    updateAtcGate(chosen);
    const gateEl = document.querySelector('[data-xoxo-atc-gate]');
    if (gateEl) {
      gateEl.hidden = false;
      try { gateEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    }
  }


  function showPreview(shouldScroll) {
    root.hidden = false;
    previewVisible = true;
    viewButton.hidden = true;
    if (mediaWrapper) mediaWrapper.classList.add('xoxo-showing-preview');
    if (shouldScroll) {
      requestAnimationFrame(() =>
        root.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        })
      );
    }
  }

  function hidePreview() {
    root.hidden = true;
    previewVisible = false;
    if (mediaWrapper) mediaWrapper.classList.remove('xoxo-showing-preview');
  }

  function contentBBox(image) {
    try {
      const sourceCanvas = document.createElement('canvas');
      sourceCanvas.width = image.naturalWidth;
      sourceCanvas.height = image.naturalHeight;
      const sourceContext = sourceCanvas.getContext('2d');
      sourceContext.drawImage(image, 0, 0);
      const pixels = sourceContext.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
      let minX = sourceCanvas.width;
      let minY = sourceCanvas.height;
      let maxX = -1;
      let maxY = -1;
      for (let py = 0; py < sourceCanvas.height; py += 2) {
        for (let px = 0; px < sourceCanvas.width; px += 2) {
          if (pixels.data[(py * sourceCanvas.width + px) * 4 + 3] > 8) {
            minX = Math.min(minX, px);
            minY = Math.min(minY, py);
            maxX = Math.max(maxX, px);
            maxY = Math.max(maxY, py);
          }
        }
      }
      if (maxX < 0) return null;
      return { minX, minY, w: maxX - minX + 1, h: maxY - minY + 1 };
    } catch (e) {
      // Tainted canvas / CORS — fall back to full image bounds
      return { minX: 0, minY: 0, w: image.naturalWidth, h: image.naturalHeight };
    }
  }

  async function draw() {
    const currentVersion = ++renderVersion;
    const chosen = selection();
    syncStonePickers(chosen.n);
    lastError = '';

    if (!isComplete(chosen)) {
      status.textContent = 'Choose Stone 1–' + chosen.n + ', then tap View preview.';
      viewButton.hidden = true;
      hidePreview();
      hasRendered = false;
      return false;
    }

    status.textContent = 'Preparing your preview…';

    const baseSrc = assetUrl(chosen.metal, 'template', chosen.n);
    const clawsSrc = assetUrl(chosen.metal, 'claws', chosen.n);
    const stoneSrcs = chosen.stones.map(monthAsset);

    if (!baseSrc || !clawsSrc || stoneSrcs.some((s) => !s)) {
      lastError = 'Missing asset URL for metal=' + chosen.metal + ' n=' + chosen.n;
      console.error('XOXO', lastError, {
        baseSrc,
        clawsSrc,
        stoneSrcs,
        attrTemplate: root.getAttribute('data-silver-template-' + chosen.n),
        datasetBrokenKey: root.dataset['silverTemplate' + chosen.n],
        datasetCorrectKey: root.dataset['silverTemplate-' + chosen.n]
      });
      hidePreview();
      viewButton.hidden = false;
      hasRendered = false;
      status.textContent = 'Preview assets missing. Please refresh and try again.';
      return false;
    }

    let baseImg, clawsImg, stoneImgs;
    try {
      [baseImg, clawsImg, ...stoneImgs] = await Promise.all([
        load(baseSrc),
        load(clawsSrc),
        ...stoneSrcs.map(load)
      ]);
    } catch (error) {
      if (currentVersion !== renderVersion) return false;
      lastError = String(error && error.message ? error.message : error);
      console.error(error);
      hidePreview();
      viewButton.hidden = false;
      hasRendered = false;
      status.textContent = 'Preview couldn’t load. Please try again.';
      return false;
    }
    if (currentVersion !== renderVersion) return false;

    const seats = seatMap[String(chosen.n)] || [];
    try {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(baseImg, 0, 0, canvas.width, canvas.height);
      stoneImgs.forEach((image, i) => {
        const seat = seats[i];
        if (!seat) return;
        const box = contentBBox(image);
        if (!box) return;
        const d = seat.d;
        ctx.drawImage(
          image,
          box.minX, box.minY, box.w, box.h,
          seat.x - d / 2, seat.y - d / 2, d, d
        );
      });
      ctx.drawImage(clawsImg, 0, 0, canvas.width, canvas.height);
    } catch (error) {
      if (currentVersion !== renderVersion) return false;
      lastError = String(error && error.message ? error.message : error);
      console.error(error);
      hidePreview();
      viewButton.hidden = false;
      hasRendered = false;
      status.textContent = 'Preview couldn’t render. Please try again.';
      return false;
    }

    hasRendered = true;
    status.textContent = previewVisible
      ? 'Your preview is ready. You can update stones or return to the options.'
      : 'Your preview is ready — tap View preview.';
    if (!previewVisible) {
      viewButton.hidden = false;
    }
    return true;
  }

  function handleChange() {
    const chosen = selection();
    syncStonePickers(chosen.n);
    updateAtcGate(chosen);
    if (!isComplete(chosen)) {
      hidePreview();
      viewButton.hidden = true;
      status.textContent = 'Choose Stone 1–' + chosen.n + ', then tap View preview.';
      hasRendered = false;
      return;
    }
    draw();
  }

  options.addEventListener('change', handleChange);
  document.addEventListener('change', (event) => {
    if (event.target.matches('variant-selects input[type="radio"], variant-selects select')) {
      handleChange();
    }
  });

  viewButton.addEventListener('click', async () => {
    status.textContent = 'Opening your preview…';
    if (!hasRendered) {
      const ok = await draw();
      if (!ok) {
        status.textContent = lastError
          ? (lastError.indexOf('Missing asset') === 0
            ? 'Preview assets missing. Please refresh and try again.'
            : 'Preview couldn’t load. Please try again.')
          : 'Choose all stones, then tap View preview.';
        return;
      }
    }
    showPreview(true);
    status.textContent = 'Your custom preview is above the gallery. Tap Back to options to keep editing.';
  });

  backButton.addEventListener('click', () => {
    hidePreview();
    viewButton.hidden = !hasRendered;
    status.textContent = hasRendered
      ? 'Your preview is ready — tap View preview.'
      : 'Choose your stones, then tap View preview.';
    options.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  });

  syncStonePickers(readStoneCount());
  hidePreview();
  viewButton.hidden = true;

  const form = findProductForm();
  if (form) {
    form.addEventListener('submit', blockIncompleteSubmit, true);
  }
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || !target.closest) return;
    if (!document.querySelector('.xoxo-atc-incomplete')) return;
    if (
      target.closest('.shopify-payment-button')
      || target.closest('shopify-accelerated-checkout')
      || target.closest('accelerated-checkout')
      || target.closest('[data-shopify="payment-button"]')
    ) {
      blockIncompleteSubmit(event);
    }
  }, true);

  // Shop Pay injects late — re-apply gate when buttons appear
  const buyHost = document.querySelector('product-form') || document.querySelector('.product-form__buttons');
  if (buyHost && typeof MutationObserver === 'function') {
    const mo = new MutationObserver(() => updateAtcGate(selection()));
    mo.observe(buyHost, { childList: true, subtree: true });
  }

  handleChange();
  updateAtcGate(selection());
})();
